import { render, staticRenderFns } from "./gifts.vue?vue&type=template&id=21a24ff1&"
import script from "./gifts.vue?vue&type=script&lang=js&"
export * from "./gifts.vue?vue&type=script&lang=js&"
import style0 from "./gifts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports